<template>
    <b-container fluid style="padding-left:0; padding-right: 0;" ref="cardlistsimple">        
        <div class="mb-3" v-for="(elem, id) in sortedElems" :key="elem['o:id']">
          <article>
            <SimpleSubStory
              :ref="'elem' + id" 
              :elem="elem"
              :elemId="id"
              :handler="handleSubstory"
              >
            </SimpleSubStory>
          </article>
          </div>
    </b-container>
</template>
<script>
const Common = require('@/Common.vue').default
import {Button} from '@/components'
import {
  hyphenateSync
} from "hyphen/it";
import SimpleSubStory from './SimpleSubStory.vue';

export default {
    components: { [Button.name]: Button },
    name: 'CardListSimple',

    data() {
      return {
        windowWidth : window.innerWidth,
      }
    },

    mounted() {
      window.addEventListener('resize', this.handleResize);
    },
    
    props: {
      elems : {
          type: Array,
          required: true
      },
      handler: {
        type: Function,
        required: false
      },
      thumbnail: {
        type: Function,
        required: true
      },
      alt: {
        type: Function,
        required: true
      },
      title: {
        type: Function,
        required: true
      },
      body: {
        type: Function,
        required: true
      },
      alwaysOnDesktop : {
        type: Boolean,
        default: false
      },
      actions: {
        type: Array,
        required: false
      },
      pointerChange: {
        type: Boolean,
        default: true
      }
    },

    computed: {
      onDesktopInner() {
        return this.windowWidth >= 768
      },
      onDesktop: function(){
        return window.innerWidth >= 768
      },
      cardClasses: function(){
        var classes = 'overflow-hidden b-card h-100' 
        if(this.$props.pointerChange)
          classes += ' b-cardPtr'
        return classes
      },
      sortedElems: function(){
        return this.sortList(this.$props.elems)
      }
    },

    
    methods: {
      handleSubstory(id) {      
          for(let i= 0; i < this.sortedElems.length; i++) {
            if(i !== id) {
                let x = this.$refs['elem' + i][0]
                x.reduce()        
            }
          }          
      },

      handleResize() {
        this.windowWidth = window.innerWidth;
      },



      
      md(st) {
        // console.log(String(st))
        // console.log(hyphenateSync(Common.removeMarkdown(st)))
        // console.log('--------')
        return hyphenateSync(Common.removeMarkdown(st))
      },
      // md: (st) => hyphenateSync(Common.removeMarkdown(st)),
      sortList: function(list){
        return list.sort(( a, b ) => {
            var aVal,bVal

            if(Common.safeString(a,["item","dcterms:tableOfContents",0,"@value"]) === ""){
              aVal = parseInt(Common.safeString(a,["dcterms:tableOfContents",0,"@value"]))
              bVal = parseInt(Common.safeString(b,["dcterms:tableOfContents",0,"@value"]))
            }
            else{
              aVal = parseInt(Common.safeString(a,["item","dcterms:tableOfContents",0,"@value"]))
              bVal = parseInt(Common.safeString(b,["item","dcterms:tableOfContents",0,"@value"]))
            }

            if(isNaN(aVal) && isNaN(bVal)){return 0}
            else if(isNaN(aVal)){return 1}
            else if(isNaN(bVal)){return -1}
            else if (aVal < bVal){return -1}
            else if ( aVal > bVal ){return 1}
            else{return 0}
        })
      }
    }
}
</script>

<style scoped lang="scss">
@import "~bootstrap/scss/functions";
@import "~bootstrap/scss/variables";
@import "~bootstrap/scss/mixins";

@include media-breakpoint-up(md) {
  .card-title{
    margin-top:2%;
    margin-bottom:2%;
  }
  .cardBody{
    padding-bottom:1%
  }
  .cardImg{
    position:absolute;
  }
  .arrowRightIcon{
    right: 15px !important;
  }
}
.cardImg{
  object-fit:cover;
  height:100%;
}
.cardBody{
  padding-top:0;
}
.b-card{
  margin-bottom:1%;
  transition: box-shadow .3s;
}
.b-cardPtr{
  cursor:pointer;
}
.b-card:hover{
  box-shadow: 0 0 10px #000000; 
}
.align {
  position:absolute;
  top:50%; 
  transform: translateY(-50%); 
}
.arrowRightIcon{
  position: absolute;
  top: 50%;
  right:-15px;
  transform: translateY(-50%);
}
</style>
